import { AwsCredentials } from 'Data/s3'
import { useDataValue } from 'Simple/Data.js'
import View from './view.js'
import React from 'react'
import { DesignTokens } from 'Simple/DesignTokens.js'

export default function Logic(props) {
  let theme = useDataValue({
    context: 'account',
    path: 'feature_flags.theme',
    viewPath: props.viewPath,
  })

  return (
    <DesignTokens viewPath={props.viewPath} theme={theme}>
      <AwsCredentials viewPath={props.viewPath}>
        <View viewPath={props.viewPath} />
      </AwsCredentials>
    </DesignTokens>
  )
}
